import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/core/_config/app.config';

@Injectable({
   providedIn: 'root',
})
export abstract class ApiServiceExtension {
   constructor(protected config: AppConfig, public http: HttpClient) {}

   public API_URL = this.config.urlApi + this.config.versionApi;
   public headers = new HttpHeaders({ 'Content-Type': 'application/json' });
}
